import { PROJECT_MODEL_LIMIT } from 'src/constants/limits';
import {
  DESIGNER_RULE_CONTENT_IRI,
  DESIGNER_RULE_DATA_IRI,
  RDFS_LABEL_IRI,
  RULE_CONTENT_IRI,
  RULE_SPARQL_RULE_IRI,
} from 'src/templates/queries/iris';
import { BindingResult } from 'src/templates/queries/types';

export type ModelRulesBindingResult = {
  iri: BindingResult;
  ruleLabel: BindingResult;
  ruleContent: BindingResult;
  designerRuleContent: BindingResult;
  ruleData: BindingResult;
};

/**
 * Determines the rules given model.
 *
 * Used to snapshot the model information of a given reasoning schema.
 *
 * **Call Frequency**
 *
 * Called once when a model is added to a project.
 *
 * **Context**
 * - Named graphs: set by the user (default is `reasoning.schema.graphs` value,
 *   which by default is `tag:stardog:api:context:local`)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# Model Rules
select * {
  ?iri a <tag:stardog:api:rule:SPARQLRule>;
    <tag:stardog:designer:rule:content> ?designerRuleContent;
    <tag:stardog:designer:rule:data> ?ruleData;
    <tag:stardog:api:rule:content> ?ruleContent;
    <http://www.w3.org/2000/01/rdf-schema#label> ?ruleLabel;
}
LIMIT 100000
 * ```
 */
export const modelRulesQuery = `# Model Rules
select * {
  ?iri a <${RULE_SPARQL_RULE_IRI}>;
    <${DESIGNER_RULE_CONTENT_IRI}> ?designerRuleContent;
    <${DESIGNER_RULE_DATA_IRI}> ?ruleData;
    <${RULE_CONTENT_IRI}> ?ruleContent;
    <${RDFS_LABEL_IRI}> ?ruleLabel;
}
LIMIT ${PROJECT_MODEL_LIMIT}`;
